import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "font-normal font-openSans" }
const _hoisted_2 = { class: "items-center justify-center flex-1" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "flex flex-col w-full sm:flex-row xl:mb-1" }
const _hoisted_5 = { class: "m-auto mt-1 sm:mt-1 md:mt-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-gray-900 sm:text-sm" }, "Already a member? ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NTitle = _resolveComponent("NTitle")!
  const _component_NFormInput = _resolveComponent("NFormInput")!
  const _component_NFormSelect = _resolveComponent("NFormSelect")!
  const _component_NFormButton = _resolveComponent("NFormButton")!
  const _component_FormSuccsess = _resolveComponent("FormSuccsess")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.signUpIsSuccsessful)
        ? (_openBlock(), _createBlock(_component_NTitle, {
            key: 0,
            class: "mb-2 text-3xl sm:mb-6 sm:text-4xl",
            tag: "h1",
            content: "Sign Up"
          }))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.signUpIsSuccsessful)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_3))
      : _createCommentVNode("", true),
    (!_ctx.signUpIsSuccsessful)
      ? (_openBlock(), _createElementBlock("form", {
          key: 1,
          class: "flex flex-col p-4 md:p-5 lg:p-7 xl:p-12 xl:px-6",
          onSubmit: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_NFormInput, {
              modelValue: _ctx.firstNameInput,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstNameInput) = $event)),
              class: "w-full mb-2 sm:mr-1",
              type: "text",
              name: "First name",
              error: _ctx.firstNameStatus.message,
              placeholder: "John",
              onInputChanged: _ctx.resetFirstNameStatus
            }, null, 8, ["modelValue", "error", "onInputChanged"]),
            _createVNode(_component_NFormInput, {
              modelValue: _ctx.lastNameInput,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastNameInput) = $event)),
              class: "w-full mb-2 sm:ml-1",
              type: "text",
              name: "Last name",
              error: _ctx.lastNameStatus.message,
              placeholder: "Doe",
              onInputChanged: _ctx.resetLastNameStatus
            }, null, 8, ["modelValue", "error", "onInputChanged"])
          ]),
          _createVNode(_component_NFormInput, {
            modelValue: _ctx.usernameInput,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.usernameInput) = $event)),
            class: "mb-2",
            type: "text",
            name: "Username",
            error: _ctx.usernameStatus.message,
            placeholder: "username",
            onInputChanged: _ctx.resetUsernameStatus
          }, null, 8, ["modelValue", "error", "onInputChanged"]),
          _createVNode(_component_NFormInput, {
            modelValue: _ctx.emailInput,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.emailInput) = $event)),
            class: "mb-2",
            type: "text",
            name: "Email",
            error: _ctx.emailStatus.message,
            placeholder: "example@mail.com",
            onInputChanged: _ctx.resetEmailStatus
          }, null, 8, ["modelValue", "error", "onInputChanged"]),
          _createVNode(_component_NFormInput, {
            modelValue: _ctx.passwordInput,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.passwordInput) = $event)),
            class: "mb-2",
            type: "password",
            name: "Password",
            error: _ctx.submitButtonClicked && !_ctx.passwordStatus.valid ? ' ' : '',
            placeholder: "Password",
            onInputChanged: _ctx.resetPasswordStatus
          }, null, 8, ["modelValue", "error", "onInputChanged"]),
          _createVNode(_component_NFormInput, {
            modelValue: _ctx.passwordConfirmInput,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.passwordConfirmInput) = $event)),
            type: "password",
            class: "mb-2",
            name: "",
            error: _ctx.passwordStatus.message,
            placeholder: "Confirm Password"
          }, null, 8, ["modelValue", "error"]),
          _createVNode(_component_NFormSelect, {
            modelValue: _ctx.selectedCountryInput,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedCountryInput) = $event)),
            items: _ctx.allCountries,
            name: 'Country',
            label: 'Select a country',
            error: _ctx.countryStatus.message,
            "show-options-above": true,
            onClick: _ctx.resetCountryStatus
          }, null, 8, ["modelValue", "items", "error", "onClick"]),
          _createElementVNode("p", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", {
              class: "text-sm font-bold text-gray-900 cursor-pointer sm:text-base",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.goToLogin && _ctx.goToLogin(...args)))
            }, "Log in.")
          ]),
          _createVNode(_component_NFormButton, {
            disabled: _ctx.submitButtonDisabled,
            type: "submit",
            class: "w-full h-10 mx-auto mt-3 shadow-sm sm:h-12 sm:mt-5 md:mt-6 lg:mt-7 xl:mt-8",
            name: "SIGN UP",
            loading: _ctx.isProcessingSignUpRequest,
            onClick: _ctx.submitForm
          }, null, 8, ["disabled", "loading", "onClick"])
        ], 32))
      : _createCommentVNode("", true),
    _createVNode(_component_FormSuccsess, {
      "button-name": "Login now!",
      title: "You have successfully signed up",
      message: "Please check your email inbox to verify your email adress.",
      "show-succsess": _ctx.signUpIsSuccsessful,
      onButtonClick: _ctx.goToLogin
    }, null, 8, ["show-succsess", "onButtonClick"])
  ]))
}